import React, {useState, useEffect} from 'react';
import './SidebarRight.css';
import { Link} from 'react-router-dom';
//import InfoIcon from '@material-ui/icons/Info';
import AnnouncementIcon from '@material-ui/icons/Announcement';
import { Avatar } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import SidebarNews from './SidebarNews';
import {useDispatch, useSelector} from 'react-redux';
import {db} from './firebase';
import {auth} from './firebase';
import {logout,selectUser} from './features/userSlice';

//<InfoIcon/>
function SidebarRight() {
    const user = useSelector(selectUser);
    const dispatch = useDispatch();
    const logoutOfApp = () => {
        dispatch(logout())
        auth.signOut();
        }

    const [news, setNews] = useState([]);

    useEffect(() => {
        db.collection("news").onSnapshot((snapshot) => 
            setNews(
                snapshot.docs.map((doc) => ({
                    id: doc.id,
                    news: doc.data(),
                }))
            )
        );
    }, []);
    const handleAddNews = () => {
        const newsName = prompt("Enter a News Title");
        
        if(newsName) {
            db.collection("news").add({
                newsName: newsName,
            });
        }
        };

    return (
        <div className="sidebarRight">
            <h2>Co+Laborar News</h2>
            <div className="sidebarRight__top">
                <h3>Latest Articles</h3>
                <AnnouncementIcon/>
            </div>

            <div className="sidebarRight__news">
                <div className="sidebarRight__newsHeader">
                    <div className="sidebarRight__header">
                    
                    <h4>Add New Article</h4>
                    </div>
                    <AddIcon onClick={handleAddNews}className="sidebarRight__addNews"/>
                </div>
            

            <div className="sidebarRight__newsList">
                <Link to="/news" exact style={{textDecoration: 'none'}}>
                {news.map(({id, news}) => (
                        <SidebarNews
                        key={id}
                        id={id}
                        newsName={news.newsName}
                        />
                    ))}
                </Link>
            </div>
        </div>

        <div className="sidebarRight__profile">
            <Avatar src={user.photoUrl}
            onClick={logoutOfApp}>{user.email[0]}
            </Avatar>
            <p>Log Out</p>
            <div className="sidebarRight__profileInfo">
                <h3>{user.displayName}</h3>
                <p>#{user.uid.substring(0,5)}</p>
            </div>

        </div>
    </div>
    )
}

export default SidebarRight
